import { useParams } from 'react-router-dom';

/**
 * The product whose page is currently open.
 *
 * An update can cover several products, so it no longer carries a single
 * `product_id`. Links back to "this update" use the product the reader is
 * actually looking at; links to a linked entity use that entity's own product.
 */
const useRouteProductId = (): string | undefined => {
  const { id } = useParams<{ id: string }>();

  return id;
};

export default useRouteProductId;
